import Image from 'next/image'
import Link from 'next/link'
import { intl } from 'src/i18n'
import { stringToHtml } from 'src/i18n/formatHtml'
import { MainLayout, AboutLayout } from 'src/layouts'
import { NEWS_ACTIVE } from 'src/consts/env'
import { FormButton } from 'src/components/GoogleForm/components/FormButton'
import styles from './styles.module.scss'

const featuresConfig = [
  {
    logo: 'heatMap',
    title: intl.t('about.generalInfo.featuresConfig.heatmap.title'),
    link: '',
    description: intl.t('about.generalInfo.featuresConfig.heatmap.description'),
  },
  {
    logo: 'watchlists',
    title: intl.t('about.generalInfo.featuresConfig.watchlist.title'),
    link: 'watchlist',
    description: intl.t(
      'about.generalInfo.featuresConfig.watchlist.description'
    ),
  },
  // {
  //   logo: 'liquidityBook',
  //   title: 'Liquidity Book',
  //   link: 'liquidity-book',
  //   description: 'For those looking for the best market liquidity'
  // },
  {
    logo: 'charts',
    title: intl.t('about.generalInfo.featuresConfig.charts.title'),
    link: 'charts',
    description: intl.t('about.generalInfo.featuresConfig.charts.description'),
  },
  {
    logo: 'widgets',
    title: intl.t('about.generalInfo.featuresConfig.widgets.title'),
    link: 'about/widgets',
    description: intl.t('about.generalInfo.featuresConfig.widgets.description'),
  },

  ...(NEWS_ACTIVE
    ? [
        {
          logo: 'releases',
          title: intl.t('about.generalInfo.featuresConfig.news.title'),
          link: 'news',
          description: intl.t(
            'about.generalInfo.featuresConfig.news.description'
          ),
        },
      ]
    : []),
]

const contactsCongif = [
  {
    logo: 'list',
    description: intl.t('about.generalInfo.contactsCongif.list.description'),
    link: 'investment@coin360.com ',
  },
  // {
  //   logo: 'alert',
  //   description: `${intl.t(
  //     'about.generalInfo.contactsCongif.alert.text1'
  //   )}<span style="color: #ffffff;">${intl.t(
  //     'about.generalInfo.contactsCongif.alert.text2'
  //   )}</span> ${intl.t('about.generalInfo.contactsCongif.alert.text3')}`,
  //   link: 'contact@coin360.com',
  //   subDescription: intl.t('about.generalInfo.contactsCongif.alert.text4'),
  // },
  {
    logo: 'questions',
    description: intl.t(
      'about.generalInfo.contactsCongif.questions.description'
    ),
    link: 'contact@coin360.com',
  },
]

const title = intl.t('about.generalInfo.seo.title')
const description = intl.t('about.generalInfo.seo.description')
const uri = '/about/generalinfo'

export const GeneralInfo = () => {
  return (
    <MainLayout fixedHeader title={title} description={description} uri={uri}>
      <AboutLayout>
        <div className={styles.wrapper}>
          <div className={styles.content}>
            {/* <EditNameAndIcon /> */}
            <div className={styles.main}>
              <h1>{intl.t('about.generalInfo.title')}</h1>
              <p>{intl.t('about.generalInfo.description')}</p>
              <p>{intl.t('about.generalInfo.description2')}</p>
              <FormButton />
            </div>
          </div>

          <div className={styles.content}>
            <h2>{intl.t('about.generalInfo.featureAndTools')}</h2>
            <div className={styles.features}>
              {featuresConfig.map(({ logo, title, description, link }) => {
                return (
                  <Link
                    className={styles.featureitem}
                    href={`../${link}`}
                    key={title}
                    target='_blank'
                    passHref
                  >
                    <Image
                      src={`/assets/images/about/general-info/general-tools-${logo}.svg`}
                      alt='title'
                      width='40'
                      height='40'
                    />
                    <h3>{title}</h3>
                    <span>{description}</span>
                  </Link>
                )
              })}
            </div>
          </div>

          <div className={styles.content}>
            <div className={styles.glance}>
              <div>
                <div className={styles.glanceimage}>
                  <Image
                    src='/assets/images/about/general-info/GeneralInfoMap.png'
                    alt='glance'
                    layout='responsive'
                    width='552'
                    height='366'
                  />
                </div>
                <div>
                  <div className={styles.glancetitle}>
                    <h2>{intl.t('about.generalInfo.glance.title')}</h2>
                  </div>
                  <p>{intl.t('about.generalInfo.glance.description')}</p>
                </div>
              </div>

              <div>
                <div className={styles.glancesecondtitle}>
                  <h2>{intl.t('about.generalInfo.glance.title2')}</h2>
                </div>
                <p
                  className={styles.glanceparagrath}
                  dangerouslySetInnerHTML={stringToHtml(
                    intl.t('about.generalInfo.glance.paragrath')
                  )}
                />
                <div className={styles.glanceimage}>
                  <Image
                    src='/assets/images/about/general-info/GeneralInfoLogoCOIN360.svg'
                    alt='glance'
                    layout='responsive'
                    width='552'
                    height='229'
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={styles.content}>
            <h2>{intl.t('about.generalInfo.contacts.title')}</h2>
            <div className={styles.contacts}>
              {contactsCongif.map(
                ({ logo, link, description, subDescription }) => {
                  return (
                    <div className={styles.contactsitem} key={logo}>
                      <div className={styles.contactsimage}>
                        <Image
                          src={`/assets/images/about/general-info/general-${logo}.png`}
                          width='45'
                          height='45'
                          alt={description}
                        />
                      </div>

                      <p>
                        <span
                          dangerouslySetInnerHTML={{ __html: description }}
                        ></span>{' '}
                        <a
                          className={styles.contactslink}
                          href={`mailto:${link}`}
                        >
                          {link}
                        </a>{' '}
                        {subDescription}
                      </p>
                    </div>
                  )
                }
              )}
              <div className={styles.contactsitem} key='advertise'>
                <div className={styles.contactsimage}>
                  <Image
                    src={`/assets/images/about/general-info/general-conversation.png`}
                    width='45'
                    height='45'
                    alt=''
                  />
                </div>
                <p>
                  {intl.t('about.generalInfo.contacts.text1')}
                  {intl.t('about.generalInfo.contacts.text2')}
                  <a
                    href='mailto:ads@coin360.com'
                    title='Advertise with Coin360.com'
                    className={styles.contactslink}
                  >
                    ads@coin360.com
                  </a>
                  {intl.t('about.generalInfo.contacts.text3')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </AboutLayout>
    </MainLayout>
  )
}

export default GeneralInfo
